import { BreadCrumbs } from './computeBreadCrumbs'
import { BrandData } from '@/types/models/Brand.model'

interface ComputeBrandBreadCrumbs {
  (props: { brand: BrandData }): {
    breadCrumbs: BreadCrumbs
    selectedTitle: string
  }
}

const computeBrandBreadCrumbs: ComputeBrandBreadCrumbs = ({ brand }) => {
  return {
    breadCrumbs: [],
    selectedTitle: brand.title || ''
  }
}

export default computeBrandBreadCrumbs
